// We need a default color to simplify the pricing calculation to describe all colors that do not have a special pricing
export enum Color {
    FALLBACK = 'default',
  
    SCHWARZ = 'schwarz',
    TITAN = 'titan',

    TITAN_GRAU = 'titangrau',
    TITAN_POLIERT = 'titanpoliert',
    KÖNIGSBLAU = 'koenigsblau',
    EISBLAU = 'eisblau',
    TÜRKIS = 'tuerkis',
    SMARAGDGRUEN = 'smaragdgruen',
    OLIVGRÜN = 'olivgruen',
    MAGENTA = 'magenta',
    FEUERROT = 'feuerrot',
    BURGUNDERROT = 'burgunderrot',
    INDIGO = 'indigo',
    BRONZE = 'bronze',
    WALNUSSBRAUN = 'walnussbraun',
    BEIGE = 'beige',
    SONNENGELB = 'sonnengelb',
    WEISS = 'weiss',
    ORANGE = 'orange',
    AMBER = 'amber'
}

// This is needed for the link buildind when sharing a configured watch
export const COLOR_ORDER = [
  Color.SCHWARZ,
  Color.TITAN,
  Color.TITAN_GRAU,
  Color.TITAN_POLIERT,
  Color.KÖNIGSBLAU,
  Color.EISBLAU,
  Color.TÜRKIS,
  Color.SMARAGDGRUEN,
  Color.OLIVGRÜN,
  Color.MAGENTA,
  Color.FEUERROT,
  Color.BURGUNDERROT,
  Color.INDIGO,
  Color.BRONZE,
  Color.WALNUSSBRAUN,
  Color.BEIGE,
  Color.SONNENGELB,
  Color.WEISS,
  Color.ORANGE,
  Color.AMBER
]